// extracted by mini-css-extract-plugin
module.exports = {"root":"IconThunder_root__1---o"};